import "./style.scss";
import { FC, useMemo } from "react";
import { IApplyInfoHistoryItem } from "@/src/types/applicationOnline";
import UserSvg from "@/src/svg/header/UserSvg";
import VerticalLine from "@/src/components/VerticalLine/VerticalLine";
import DotsSvg from "@/src/svg/applicationsPage/APPopUp/Documents/DotsSvg";
import { useFormatDateDisplay } from "@/src/hooks/useFormatDateDisplay";

interface HistoryProps {
  items: IApplyInfoHistoryItem[];
}

const parseCreatedAt = (value?: string): number => {
  if (!value) return 0;
  const dmyHm = value.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})(?:[ ,](\d{2}):(\d{2})(?::\d{2})?)?$/);
  if (dmyHm) {
    const [, d, m, y, h = "00", min = "00"] = dmyHm;
    return Date.UTC(Number(y), Number(m) - 1, Number(d), Number(h), Number(min));
  }
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const History: FC<HistoryProps> = ({ items }) => {
  const formatDateDisplay = useFormatDateDisplay();
  const sortedItems = useMemo(
    () => [...items].sort((a, b) => parseCreatedAt(b.created_at) - parseCreatedAt(a.created_at)),
    [items],
  );

  return (
    <>
      {items.length === 0 ? (
        <div className="history-empty">
          <p>No changes yet</p>
        </div>
      ) : (
        <div className="history-list">
          {sortedItems.map((item, index) => (
              <div key={`${item.student_id}-${item.created_at}-${index}`} className="history-list-item">
                <div className="history-list-item-logo">
                  <UserSvg />
                </div>
                <div className="history-list-item-container">
                  <div className="history-list-item-header">
                    <div className="history-list-item-header-title">
                      <p>{item.employee_name ?? "name"}</p>
                      <VerticalLine />
                      <span>{item.employee_role ?? "role"}</span>
                    </div>
                    <div className="history-list-item-header-date">
                      <p>{formatDateDisplay(item.created_at)}</p>
                      <DotsSvg />
                    </div>
                  </div>
                  <div className="history-list-item-body">
                    <p>{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </>
  );
};

export default History;
